import { useMutation } from '@tanstack/react-query'

import type { InitiateDepositRequest, InitiateDepositResponse } from '../../types/deposit.js'

import { apiClient } from '../../lib/client.js'

export const useInitiateDepositMutation = () => {
  return useMutation({
    mutationFn: async (data: InitiateDepositRequest) => {
      const response = await apiClient.client.post<InitiateDepositResponse>(
        '/payment/initiate-deposit',
        data
      )
      return response.data
    },
  })
}
